import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ApiService } from 'app/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from 'app/services/utility.service';
import { AuthService } from 'app/services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-pdf-outline-view',
  templateUrl: './pdf-outline-view.component.html',
  styleUrls: ['./pdf-outline-view.component.scss']
})
export class PdfOutlineViewComponent implements OnInit, OnDestroy {
  outlinePreview = {};
  disableBtn: boolean = true;
  public showPreview = false;
  @ViewChild('popUp', { static: false }) public lgModal;
  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: false
  };
  public modalRef: BsModalRef;

  constructor(private route: ActivatedRoute, private apiService: ApiService, private utilityService: UtilityService,
    private modalService: BsModalService,private authService: AuthService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.spinner.show();
    this.route.params.subscribe(params => {
      this.openOutlinePreview(params['id']);
    });
  }

  openOutlinePreview(id) {
    this.showPreview = false;
    this.apiService.get('/outlineApproval/' + id).subscribe((response: any) => {

      response.projectOutline = this.utilityService.setOutlinePdfValues(response.projectOutline);
      this.outlinePreview = response.projectOutline;

      setTimeout(() => {
        this.showPreview = true;
      }, 100);
      setTimeout(() => {
        document.getElementById("download").style.display = "none";
      }, 100);

      this.spinner.hide();

      this.modalRef = this.modalService.show(this.lgModal, this.config);
      this.modalService.onHidden.subscribe((reason: string) => {
        this.showPreview = false;
      });
    }, (error) => {
      this.apiService.get('/projectOutline/' + id).subscribe(responseOutline => {

        responseOutline = this.utilityService.setOutlinePdfValues(responseOutline);
        this.outlinePreview = responseOutline;

        setTimeout(() => {
          this.showPreview = true;
        }, 100);
        setTimeout(() => {
          document.getElementById("download").style.display = "none";
        }, 100);

        this.spinner.hide();

        this.modalRef = this.modalService.show(this.lgModal, this.config);
        this.modalService.onHidden.subscribe((reason: string) => {
          this.showPreview = false;
        });
      });
    });
  }

  ngOnDestroy() {
    this.modalRef.hide();
  }

}
